import React, { forwardRef } from 'react';
import styled from 'styled-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Paper } from '@clds/paper';
import { focusRing } from '@clds/style-utils';
import { useListStyle } from './ListStyleProvider.js';
import { popoverMaxHeightVariant } from './theme.js';
const PaperWithFocusRing = styled(Paper) `
  max-height: ${popoverMaxHeightVariant((variant) => variant.maxHeight)};
  ${({ maxHeight }) => maxHeight !== undefined &&
    maxHeight !== 'none' &&
    `
        overflow: auto;
    `}
  ${focusRing()}
`;
/**
 * Pure list component which provides list items container style
 */
// eslint-disable-next-line react/display-name
export const ListPure = forwardRef(({ children, borderRadius, depth, ...rest }, ref) => (React.createElement(PaperWithFocusRing, { role: "list", ...rest, borderRadius: borderRadius, depth: depth, ref: ref }, children)));
/**
 * List component that reads variant from context
 */
// eslint-disable-next-line react/display-name
export const DefaultList = forwardRef((props, ref) => {
    const listContext = useListStyle();
    return React.createElement(ListPure, { ...listContext, ...props, ref: ref });
});
//# sourceMappingURL=List.js.map